export default __webpack_public_path__ + "static/media/imageLogo1.27601faa.png";